import api from '../services/api'

// Actions
const FETCH_GAMES_SUCCESS = 'ascension/game/feth-games-success'
const UPDATE_GAME_ID = 'ascension/game/update-id'
const UPDATE_GAME_STATE = 'ascension/game/update-state'
const UPDATE_FINISH_TIME = 'ascension/game/update-finish-time'
const SUBMIT_ROUND_START = 'ascension/game/submit-round-start'
const SUBMIT_ROUND_SUCCESS = 'ascension/game/submit-round-success'
const SUBMIT_ROUND_ERROR = 'ascension/game/submit-round-error'
const LOCK_SCREEN = 'ascension/game/lock-screen'
const UPDATE_SELECTED_ROUND = 'ascension/game/update-selected-round'
const HAS_DOWNLOADED_CUSTOM_LOGO = 'ascension/game/has-downloaded-custom-logo'
export const RESET = 'ascension/game/reset'

// Reducer
const initialState = {
  gameId: null,
  gameName: null,
  appTitle: null,
  hasCustomLogo: false,
  hasDownloadedCustomLogo: false,
  splashScreenTitle: null,
  selectedRound: 0,
  currentRound: 0,
  currentRoundSetup: {
    insightsEnabled: false,
    dealsEnabled: false,
    excoEnabled: false,
    specialProjectsEnabled: false,
    surveyEnabled: false
  },
  roundsSetup: [],
  totalRounds: 1,
  state: 'locked',
  finishTime: null,
  warningMessage: null,
  submitError: null,
  automate: {
    testModeScreen: false,
    menuTimeMax: 0,
    menuTimeMin: 0,
    testModeWidgets: false,
    widgetTimeMin: 0,
    widgetTimeMax: 0
  },
  games: {}
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_GAME_STATE: {
      return {
        ...state,
        gameId: action.data.gameId,
        gameName: action.data.gameName,
        appTitle: action.data.appTitle,
        splashScreenTitle: action.data.splashScreenTitle,
        hasCustomLogo: !!action.data.filesToDownload.find(f => f.name === 'logo.png'),
        state: action.data.status,
        selectedRound: action.data.currentRound === state.currentRound ? state.selectedRound : action.data.currentRound,
        currentRound: action.data.currentRound,
        currentRoundSetup: action.data.currentRoundSetup,
        roundsSetup: action.data.roundsSetup,
        totalRounds: action.data.totalRounds,
        warningMessage: action.data.warningMessage,
        automate: action.data.automate || state.automate
      }
    }
    case FETCH_GAMES_SUCCESS: {
      return {
        ...state,
        games: {
          ...state.games,
          [action.data.hostname]: action.data.games
        }
      }
    }
    case UPDATE_GAME_ID: {
      return {
        ...state,
        gameId: action.data
      }
    }
    case UPDATE_SELECTED_ROUND: {
      return {
        ...state,
        selectedRound: action.data
      }
    }
    case UPDATE_FINISH_TIME: {
      return {
        ...state,
        finishTime: action.data
      }
    }
    case LOCK_SCREEN:
    case SUBMIT_ROUND_SUCCESS: {
      return {
        ...state,
        state: 'locked'
      }
    }
    case SUBMIT_ROUND_ERROR: {
      return {
        ...state,
        submitError: action.data // TODO: display error on splash screen || send back to page && error
      }
    }
    case RESET: {
      return initialState
    }
    case HAS_DOWNLOADED_CUSTOM_LOGO: {
      return {
        ...state,
        hasDownloadedCustomLogo: action.data
      }
    }
    default: return state
  }
}

export default reducer

export function changeGameState (data) {
  return {
    type: UPDATE_GAME_STATE,
    data
  }
}

export function submitRound (currentRound, teamId) {
  return async (dispatch) => {
    dispatch(submitRoundStart(currentRound, teamId))

    try {
      const response = await api.submitRound(currentRound, teamId)
      dispatch(submitRoundSuccess(response))
    } catch (e) {
      dispatch(submitRoundError(e))
    }
  }
}

export function submitRoundStart () {
  return {
    type: SUBMIT_ROUND_START
  }
}

export function submitRoundSuccess (data) {
  return {
    type: SUBMIT_ROUND_SUCCESS,
    data
  }
}

export function submitRoundError (error) {
  return {
    type: SUBMIT_ROUND_ERROR,
    data: error
  }
}

export function changeFinishTime (finishTime) {
  return {
    type: UPDATE_FINISH_TIME,
    data: finishTime
  }
}

export function lockScreen () {
  return {
    type: LOCK_SCREEN
  }
}

export function updateSelectedRound (round) {
  return {
    type: UPDATE_SELECTED_ROUND,
    data: round
  }
}

export function reset () {
  return {
    type: RESET
  }
}

export function updateGameId (gameId) {
  return {
    type: UPDATE_GAME_ID,
    data: gameId
  }
}

export function hasDownloadedCustomLogo (hasDownloadedCustomLogo) {
  return {
    type: HAS_DOWNLOADED_CUSTOM_LOGO,
    data: hasDownloadedCustomLogo
  }
}

export function fetchGamesSuccess (hostname, games) {
  return {
    type: FETCH_GAMES_SUCCESS,
    data: { hostname, games }
  }
}

export function getGames (hostname) {
  return async (dispatch) => {
    try {
      const games = await api.getGames(hostname)
      dispatch(fetchGamesSuccess(hostname, games))
    } catch (e) {
    }
  }
}
